/* eslint-disable camelcase */
import { IPrivateApiFields } from './CommonTypes';

/**
 * String enum of possible user roles.
 * @category API Types
 */
export enum UserRoles {
    SALES = 'sales',
    USER = 'user',
    ADMINISTRATOR = 'administrator'
}

/**
 * String enum of possible user permission features.
 * @category API Types
 */
export enum UserPermissionFeatures {
    DRIVER_BOOKING = 'driver_booking',
    DRIVER_MANAGEMENT = 'driver_management',
    PLANNING = 'planning',
    USER_MANAGEMENT = 'user_management',
    TASK_MANAGEMENT = 'task_management'
}

/**
 * String enum of possible user permission roles.
 * @category API Types
 */
export enum UserPermissionRoles {
    EDITOR = 'editor',
    NO_ACCESS = 'no_access',
    VIEWER = 'viewer'
}

/**
 * Type for API user access
 * @category API Types
 */
export type ApiUserAccess = IPrivateApiFields & {
    client: string;
    roles: Array<UserRoles>;
};

/**
 * Type for API user
 * @category API Types
 */
export type ApiUser = IPrivateApiFields & {
    /**
     * the user's id
     */
    id: string;
    /**
     * the user's username
     */
    username: string;
    /**
     * the user's email address
     */
    email: string;
    /**
     * the user's firstname
     */
    firstname: string;
    /**
     * the user's lastname
     */
    lastname: string;
    /**
     * the related client's id
     */
    client: string;
    /**
     * the user's roles
     */
    roles: Array<UserRoles>;
    /**
     * the user's access
     */
    access: Array<ApiUserAccess>;
};

export type UserRolesAndPermissions = {
    role: UserPermissionRoles;
    feature: UserPermissionFeatures;
};

export type UserClientAccess = {
    client_id: string;
    permission: Array<UserRolesAndPermissions>;
};

/**
 * Type of API user group
 * @category API Types
 */
export interface ApiUserGroup {
    id: string;
    client_id: string;
    owner_id: string;
    name: string;
    client_access: Array<UserClientAccess>;
}
